import { useState } from 'react';
import { ChevronDown, ChevronRight, Wrench } from 'lucide-react';
import { renderProvenanceItem, type ProvenanceContext } from './ProvenanceItemRenderer';
import type { AgentHistoryItem } from './provenance-entry-item';

export interface ProvenanceCollapsedSequenceProps {
  items: AgentHistoryItem[];
  context?: ProvenanceContext;
}

export function ProvenanceCollapsedSequence({ items, context }: ProvenanceCollapsedSequenceProps) {
  const [expanded, setExpanded] = useState(false);
  const actionCount = items.filter((i) => i.kind === 'tool_result').length;
  const density = context?.density ?? 'compact';
  const innerSpacing = density === 'comfortable' ? 'space-y-4' : 'space-y-3';

  if (!expanded) {
    return (
      <button
        type="button"
        onClick={() => setExpanded(true)}
        data-testid="speak2me-collapsed-sequence"
        className="w-full text-xs text-muted-foreground inline-flex items-center gap-2 hover:text-foreground transition-colors text-left"
      >
        <ChevronRight className="h-3.5 w-3.5 shrink-0" />
        <Wrench className="h-3.5 w-3.5 shrink-0" />
        <span>Performed {actionCount} action{actionCount === 1 ? '' : 's'}</span>
      </button>
    );
  }

  return (
    <div className="w-full" data-testid="speak2me-expanded-sequence">
      <button
        type="button"
        onClick={() => setExpanded(false)}
        className="w-full text-xs text-muted-foreground inline-flex items-center gap-2 hover:text-foreground transition-colors text-left mb-2"
      >
        <ChevronDown className="h-3.5 w-3.5 shrink-0" />
        <Wrench className="h-3.5 w-3.5 shrink-0" />
        <span>Performed {actionCount} action{actionCount === 1 ? '' : 's'}</span>
      </button>
      <div className={innerSpacing}>
        {items.map((item) => (
          <div key={`${item.kind}:${item.id}`}>
            {renderProvenanceItem(item, context)}
          </div>
        ))}
      </div>
    </div>
  );
}
